import {
  EVENT_VIEW_MODES,
  EVENT_MEDIA_MODES,
  EVENTS_ROUTE_NAMES,
  type EventViewMode,
  type EventMediaMode,
} from '~/shared/lib/events-routes.const';
import { EVENT_TIME_FILTERS, type EventTimeFilter } from './const';

const VIEW_MODE_ROUTE: Record<EventViewMode, string> = {
  [EVENT_VIEW_MODES.afisha]: EVENTS_ROUTE_NAMES.afisha,
  [EVENT_VIEW_MODES.media]: EVENTS_ROUTE_NAMES.photos,
  [EVENT_VIEW_MODES.schedule]: EVENTS_ROUTE_NAMES.schedule,
};

const MEDIA_MODE_ROUTE: Record<EventMediaMode, string> = {
  [EVENT_MEDIA_MODES.photos]: EVENTS_ROUTE_NAMES.photos,
  [EVENT_MEDIA_MODES.videos]: EVENTS_ROUTE_NAMES.videos,
};

export function useEventsFilters() {
  const route = useRoute();
  const router = useRouter();

  const timeFilter = computed<EventTimeFilter>(() => {
    const value = route.query.time_filter as string;
    if (value === EVENT_TIME_FILTERS.past) {
      return EVENT_TIME_FILTERS.past;
    }
    if (value === EVENT_TIME_FILTERS.upcoming) {
      return EVENT_TIME_FILTERS.upcoming;
    }
    return EVENT_TIME_FILTERS.all;
  });

  const viewMode = computed<EventViewMode>(
    () => (route.meta.tab as EventViewMode) ?? EVENT_VIEW_MODES.afisha,
  );

  const mediaMode = computed<EventMediaMode>(
    () => (route.meta.mediaMode as EventMediaMode) ?? EVENT_MEDIA_MODES.photos,
  );

  const setTimeFilter = (filter: EventTimeFilter) => {
    const nextFilter =
      filter === timeFilter.value ? EVENT_TIME_FILTERS.all : filter;
    router.push({
      query: {
        ...route.query,
        time_filter:
          nextFilter === EVENT_TIME_FILTERS.all ? undefined : nextFilter,
        page: undefined,
      },
    });
  };

  const setViewMode = (mode: EventViewMode) => {
    router.push({
      name: VIEW_MODE_ROUTE[mode],
      query: { time_filter: route.query.time_filter },
    });
  };

  const setMediaMode = (mode: EventMediaMode) => {
    router.push({
      name: MEDIA_MODE_ROUTE[mode],
      query: { time_filter: route.query.time_filter },
    });
  };

  return {
    timeFilter,
    viewMode,
    mediaMode,
    setTimeFilter,
    setViewMode,
    setMediaMode,
  };
}
